import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import { Toast } from 'vant';
import { i18n } from './lang/index'
import navbar from "@/components/navbar.vue";
import 'vant/lib/index.css';
import './style/base.css'
import "amfe-flexible";
import api from "./api/api";
import { SERVERTAPI } from "@/config";
// 引入iconfont图标
Vue.use(Vant)
Vue.prototype.$http = api;
Vue.prototype.$toast = Toast;
Vue.prototype.$baseUrl = SERVERTAPI;
Vue.config.productionTip = false
Vue.component('navbar', navbar)
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
